import React from "react";
import { HorizontalBar } from "react-chartjs-2";

const data = {
  labels: [
    "Barrel bomb",
    "Bunker-buster bomb",
    "Chemical weapons",
    "Cluster munition",
    "Incendiary weapons",
  ],
  datasets: [
    {
      label: "# of incidents",
      data: [25, 1, 2, 7, 4],
      backgroundColor: [
        "rgba(217, 156, 127, 0.2)",
        "rgba(217, 156, 127, 0.2)",
        "rgba(217, 156, 127, 0.2)",
        "rgba(217, 156, 127, 0.2)",
        "rgba(217, 156, 127, 0.2)",
      ],
      borderColor: [
        "rgba(179, 58, 0, 1)",
        "rgba(179, 58, 0, 1)",
        "rgba(179, 58, 0, 1)",
        "rgba(179, 58, 0, 1)",
        "rgba(179, 58, 0, 1)",
      ],
      borderWidth: 1,
    },
  ],
};

const legendOpts = {
  labels: {
    fontColor: "rgb(255, 255, 255)",
  },
};

const options = {
  scales: {
    xAxes: [
      {
        ticks: {
          beginAtZero: true,
          fontColor: "white",
        },
      },
    ],
    yAxes: [
      {
        ticks: {
          beginAtZero: true,
          fontColor: "white",
        },
      },
    ],
  },
};

const UnlawfulWeaponsChart = () => (
  <div
    css={{
      position: "relative",
      zIndex: 3,
      backgroundColor: "black",
      marginTop: "2rem",
      marginBottom: "2rem",
    }}
  >
    <HorizontalBar data={data} options={options} />
  </div>
);

export default UnlawfulWeaponsChart;
